export function isSportsOrSpecials(type:string) {
    return type === 'sports' || type === 'specials';
}
export function isLotto(type:string) {
    return type === 'lotto';
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/terminal/app/modules/checkTicket/util.ts